import ProdutoDetalhe from './ProdutoDetalhe';

export default ProdutoDetalhe;